import generateQueryUrl from '@helpers/generateQueryUrl';
import { apiGet } from '@lib/api/apiClient';

export const getWinePageInformation = ({
  wineId,
  year,
  priceId,
  bottleCount = null,
}): Promise<{ page_information: any }> => {
  const params = [
    { name: 'year', value: year },
    { name: 'price_id', value: priceId },
  ];
  if (bottleCount) {
    params.push({ name: 'bottle_count', value: bottleCount });
  }

  const url = generateQueryUrl({
    params,
    baseUrl: `/api/wines/${wineId}/page_information`,
  });

  return apiGet({ url });
};
